import React from "react";

export default function NoUsers() {

    return(
        <tr className={'users__table--empty'}>
            <td colSpan="13">
                <div className="users__empty">
                    <div className="users__empty--centered">
                        <p className="muted-title">No users available.</p>
                        <a className={'gray-link'} href={'/group/licenses'}>Start Inviting</a>
                    </div>
                </div>
            </td>
        </tr>
    )

}